module.exports = __webpack_public_path__ + "static/device_computer.9a0bc725.png";